import http from '@/http/index';

// 列表
export function login(params) {
    return http.post('/api/admin/auth/login', undefined, {params});
}

// 修改密码
export function updatePasswd(params) {
    return http.get('/api/admin/user/updatePasswd', params);
}
